module.exports = __webpack_public_path__ + "static/p3-2101d6a79af30060944ebc16500b9ea1.png";